// extracted by mini-css-extract-plugin
export var backButton = "_1w-1";
export var content = "_1w-d";
export var continueButton = "_1w-7";
export var continueHint = "_1w-8";
export var continueRow = "_1w-6";
export var leftInner = "_1w-0";
export var sidebarContent = "_1w-5";
export var skipButton = "_1w-c";
export var spacer = "_1w-2";
export var spin = "_1w-a";
export var spinner = "_1w-9";
export var spinnerOverlay = "_1w-b";
export var subtitle = "_1w-4";
export var title = "_1w-3";